import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import {
  BENCHMARK_MODELLED_CONV_NAME,
  MODELLED_CONV_NAME,
} from '../utils/constants';

/**
 * Legend labelMap translating the internal conversion data keys into
 * metric-aware display labels — KPI metrics are dynamic per model, so
 * "Conversions" copy must follow the model's actual metric. Data keys stay
 * constant (row/chart identifiers); only the rendered labels change.
 */
export const useKpiMetricLabelMap = (): Record<string, string> => {
  const { metricLabel } = useKpiMetricLabels();

  return {
    [MODELLED_CONV_NAME]: `Modelled Media-Driven ${metricLabel}`,
    [BENCHMARK_MODELLED_CONV_NAME]: `${metricLabel} (Bench)`,
  };
};
